<div class="table-container m-t-12">
  @if (
    ((getMyQueueApiCallStatus === 'COMPLETED_SUCCESFULLY' || getMyPoolApiCallStatus === 'COMPLETED_SUCCESFULLY') && data.length > 0) ||
    getMyQueueApiCallStatus === 'IN_PROGRESS' ||
    getMyPoolApiCallStatus === 'IN_PROGRESS'
  ) {
    <mc-table
      data-cy="work-order-list"
      [data]="
        (getMyPoolApiCallStatus === 'COMPLETED_SUCCESFULLY' || getMyQueueApiCallStatus === 'COMPLETED_SUCCESFULLY') && data.length > 0
          ? data
          : mockDataForLoadingAnimation
      "
      fit="small"
      [columns]="columns"
      nowrap="true"
      sortmanual
      sortdefaultdirection="ascending"
      (sortchange)="onSortDirectionChange($event)"
      tabularFigures="true"
      headersticky
      height="100%">
      @for (row of data; track row; let i = $index) {
        @if (row.isPriority) {
          <div slot="{{ row.id }}_isPriority" class="priority-flag">
            <mc-tooltip appearance="neutral-default">
              <mc-icon slot="trigger" (click)="onClick(row)" icon="flag"></mc-icon>
              <div>High priority</div>
            </mc-tooltip>
          </div>
        }
        @if (!row.isPriority && receivedTabVal === 'MyPool') {
          <div slot="{{ row.id }}_isPriority" class="priority-icon">
            <mc-tooltip appearance="neutral-default">
              <mc-icon slot="trigger" (click)="onClick(row)" icon="flag"></mc-icon>
              <div>Set to high priority</div>
            </mc-tooltip>
          </div>
        }
        @if (!row.isPriority) {
          <div slot="{{ row.id }}_isPriority"></div>
        }
        <div slot="{{ row.id }}_maintenanceOrderNumber" class="pure-g">
          <a [routerLink]="[urlNavigate, row.maintenanceOrderNumber]">{{ row.maintenanceOrderNumber }}</a>
          @if (row.isOnHold) {
            <mc-tooltip appearance="neutral-default" style="margin-left: 5px">
              <mc-icon slot="trigger" icon="pause-circle" class="on-hold"></mc-icon>
              <div>On hold</div>
            </mc-tooltip>
          }
        </div>
      }
      @for (row of mockDataForLoadingAnimation; track $index) {
        @for (item of columns; track $index) {
          <div slot="{{ row.id }}_{{ item.id }}">
            <app-loader></app-loader>
          </div>
        }
      }
    </mc-table>
  } @else {
    <div class="pure-g">
      <div class="pure-u-md-24-24 pure-u-lg-24-24 pure-u-xl-24-24 m-t-180 flex-container flex-center no-data">
        <span i18n>No Data Found</span>
      </div>
    </div>
  }
</div>
@if (data.length > 0) {
  <div class="pure-g m-t-16 footer">
    <div class="pure-u-md-6-24 pure-u-lg-4-24 pure-u-xl-4-24">
      <mc-select
        style="width: 140px; display: block"
        [value]="pageLimit"
        optionswidth="100px"
        ngDefaultControl
        label="Per page"
        labelposition="left"
        fit="small"
        (optionselected)="onPageLimitChange($event)">
        @for (pageCount of [10, 20, 50, 100, 200]; track $index) {
          <mc-option [value]="pageCount">{{ pageCount }}</mc-option>
        }
      </mc-select>
    </div>

    <div class="pure-u-md-12-24 pure-u-lg-16-24 pure-u-xl-16-24 flex-container flex-center">
      @if (data.length != totalItemCount) {
        <mc-pagination
          hiddenlabels
          [currentpage]="currentPage"
          [totalpages]="lastPage"
          visiblepages="7"
          (pagechange)="onPageChange($event)"
          fit="small">
        </mc-pagination>
      }
    </div>

    <div class="pure-u-md-6-24 pure-u-lg-4-24 pure-u-xl-4-24 text-align-right">
      <span class="page-description" i18n>Showing {{ data.length }} of {{ totalItemCount }}</span>
    </div>
  </div>
}
